import request from '@/utils/request'
// 获取服务归属统计信息
export const getServiceSatics = params => {
  return request({
    url: 'strong-doctor-center-application/auth/application/serviceBelong/service/statics',
    method: 'get',
    params
  })
}

// 获取服务服务进度
export const getServiceProgress = params => {
  return request({
    url: 'strong-doctor-center-application/auth/application/serviceBelong/service/progress',
    method: 'post',
    data: params
  })
}

// 随访结果
export const getFormConfig = data => {
  return request({
    url: `strong-doctor-center-application/auth/application/serviceBelong/service/follow/result`,
    method: 'get',
    params: data
  })
}

// 问卷结果
export const getQuestionResult = params => {
  return request({
    url: 'health-doctor/cure/survey/question/result',
    method: 'get',
    params
  })
}

// 获取服务患者列表
export const getServicePatients = data => {
  return request({
    url: '/strong-doctor-center-application/auth/application/serviceBelong/servicePatients/query',
    method: 'post',
    data
  })
}

// 获取服务订单列表
export const getServiceOrderList = data => {
  return request({
    url: '/strong-doctor-center-application/auth/application/serviceBelong/servicePatients/details',
    method: 'post',
    data
  })
}

// 获取服务事项列表
export const getServiceTipList = params => {
  return request({
    url: '/strong-doctor-center-application/auth/application/serviceBelong/service/detail',
    method: 'get',
    params
  })
}

// 获取服务患者信息
export const getPatientInfo = ucUserId => {
  return request({
    url: `/health-user/user/patient/selectByUcUserId?ucUserId=${ucUserId}`,
    method: 'post'
  })
}
